import * as React from "react";
import { useParams } from "react-router-dom";
import { toast } from "sonner";
import { EntityDrawer } from "src/components/entity-drawer";
import PaymentDescCard from "src/components/payment-desc-card/payment-desc-card";
import useActiveMerchantId from "src/hooks/use-merchant-id";
import paymentsQueries from "src/queries/payments-queries";
import type { Payment } from "src/types";

const PaymentDetail: React.FC = () => {
	const { paymentId } = useParams<{ paymentId: string }>();
	const { merchantId } = useActiveMerchantId();
	const getPayment = paymentsQueries.getPayment();

	const [isLoading, setIsLoading] = React.useState(true);
	const [payment, setPayment] = React.useState<Payment | null>(null);
	const [isNotFound, setIsNotFound] = React.useState(false);

	// biome-ignore lint/correctness/useExhaustiveDependencies: getPayment.mutateAsync is stable
	React.useEffect(() => {
		if (!paymentId || !merchantId) return;

		const fetchPayment = async () => {
			try {
				setIsLoading(true);
				const data = await getPayment.mutateAsync(paymentId);
				setPayment(data);
				setIsNotFound(false);
			} catch (error) {
				console.error("Failed to fetch payment:", error);
				setIsNotFound(true);
			} finally {
				setIsLoading(false);
			}
		};

		fetchPayment();
	}, [paymentId, merchantId]);

	const openNotification = (title: string, description: string) => {
		toast.success(title, {
			description,
		});
	};

	return (
		<EntityDrawer
			title="Payment details"
			isLoading={isLoading}
			isNotFound={isNotFound}
			notFoundMessage="Payment not found"
			parentPath="/payments"
		>
			{payment && (
				<div className="p-4 sm:p-6">
					<PaymentDescCard
						data={payment}
						openNotificationFunc={openNotification}
					/>
				</div>
			)}
		</EntityDrawer>
	);
};

export default PaymentDetail;
